<template>
<div class="full-width card-rows">
  <habit :habit="habit" v-for="habit in habits" :key="habit.id" @deleted="remove(habit)"/>
</div>
</template>

<script>
import store from "@/services/api/store";
const CLIENT_STORE = "ClientHabits";
import habit from "./habit";

export default {
  components: { habit },
  props: ["bus"],
  data() {
    return {
      habits: []
    };
  },
  created() {
    store.findAll(CLIENT_STORE, {limit: 100}, { bypassCache: true }).then(r => {
      this.habits = r;
    });
    this.bus.$on('newHabit', (habit) => {
      this.habits = [habit, ...this.habits]
    })
  },
  methods: {
    remove(habit) {
      this.habits = this.habits.filter(h => h != habit);
    }
  }
};
</script>

<style lang="less" scoped>

</style>
